import { useEffect, useState, Fragment, useContext } from 'react';

import {
  Grid,
  Paper,
  Typography,
  FormControlLabel,
  Checkbox,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  TableHead,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import BlockIcon from '@material-ui/icons/Block';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import InfoIcon from '@material-ui/icons/Info';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import NoteIcon from '@material-ui/icons/Note';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { getSales, updateSale } from '../../services/sales.service';
import { salesStatus } from '../../constants/sales.constants';
import { paymentMethods } from '../../constants/payment.constants';
import { getProducts } from '../../services/products.service';
import { BackdropComponent } from '../commons/backdrop/backdrop.component';
import { ProductsContext } from '../../context/products.context';

export const SalesComponent = () => {

  const history = useHistory();

  const { enqueueSnackbar } = useSnackbar();

  const productsContext = useContext(ProductsContext);

  const [pickedDate, setPicketDate] = useState(new Date());

  const [allSales, setAllSales] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [page, setPage] = useState(0);

  const [sales, setSales] = useState([]);

  const [displaySales, setDisplaySales] = useState([]);

  const [open, setOpen] = useState(false);

  const [selectedSale, setSelectedSale] = useState();

  const [cancelReason, setCancelReason] = useState('');

  const [view, setView] = useState(false);

  const [allProducts, setAllProducts] = useState([]);

  const [loading, setLoading] = useState(true);

  const handleDateChange = (date) => {
    setPicketDate(date);
    getSalesItems(date);
  }

  const handleCheckbox = () => {
    setAllSales(!allSales);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getSalesItems = async (date) => {
    const salesItems = await getSales(date);
    setSales(salesItems);
    const onlyProgress = salesItems.filter(sale => sale.status === 'progress');
    setDisplaySales(onlyProgress);
  }

  const fetchProducts = async () => {
    const productsItems = await getProducts();
    productsContext.handleProducts(productsItems);
    setAllProducts(productsItems);
    setLoading(false);
  }

  useEffect(() => {
    getSalesItems(pickedDate);
    if (productsContext.products.length === 0) {
      fetchProducts();
    } else {
      setAllProducts(productsContext.products);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setOpen(false);
  }

  const handleViewClose = () => {
    setView(false);
  }

  const cancelSale = async (id, sale) => {
    const update = {
      ...sale,
      status: 'canceled',
      notes: cancelReason
    }
    const updateItem = await updateSale(id, update);
    setSales(sales.map(sale => sale.id === id ? updateItem : sale));
    setDisplaySales(displaySales.map(sale => sale.id === id ? updateItem : sale));
    setOpen(false);
    enqueueSnackbar('Venta cancelada', {
      variant: 'success',
      resumeHideDuration: 3000,
      anchorOrigin:
        { horizontal: 'right', vertical: 'bottom' },
    });
  }

  const handleCancel = (sale) => {
    setSelectedSale(sale);
    setOpen(true);
  }

  const handleView = (sale) => {
    setSelectedSale(sale);
    setView(true);
  }

  const getProduct = (productId) => {
    return allProducts.find(p => p.id === productId);
  }

  return loading ? (
    <BackdropComponent />
  ) : (
    <Fragment>
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => history.push('/sales/new')}
              >
                Crear venta
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker format="dd/MM/yyyy" value={pickedDate} onChange={handleDateChange} />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={allSales}
                        onChange={() => handleCheckbox()}
                        name="allSales"
                        color="primary"
                      />
                    }
                    label="Ver todas las ventas"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table aria-label="ventas">
                  <TableHead>
                    <TableRow>
                      <TableCell>Mesa</TableCell>
                      <TableCell>Importe</TableCell>
                      <TableCell>Hora</TableCell>
                      <TableCell>Estatus</TableCell>
                      <TableCell align="right">Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? allSales ? sales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : displaySales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : allSales ? sales : displaySales
                    ).map((sale, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          {sale.table}
                        </TableCell>
                        <TableCell>
                          ${sale.total}
                        </TableCell>
                        <TableCell>
                          {sale.date.split(' ')[1]}
                        </TableCell>
                        <TableCell>
                          {salesStatus[sale.status]}
                        </TableCell>
                        <TableCell align="right">
                          <Grid container justifyContent="flex-end" spacing={1}>
                            <Grid item>
                              <IconButton
                                aria-label="view"
                                onClick={() => handleView(sale)}
                              >
                                <InfoIcon fontSize="small" />
                              </IconButton>
                            </Grid>
                            <Grid item>
                              <IconButton
                                aria-label="edit"
                                onClick={() => history.push(`/sales/${sale.id}/edit`)}
                                disabled={sale.status !== 'progress'}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Grid>
                            <Grid item>
                              <IconButton
                                aria-label="delete"
                                disabled={sale.status === 'canceled'}
                                onClick={() => handleCancel(sale)}
                              >
                                <BlockIcon fontSize="small" />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ))}
                    {sales.length === 0 && (
                      <Typography align="center" variant="body1">
                        No hay ventas
                      </Typography>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={allSales ? sales.length : displaySales.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="cancel-dialog"
        aria-describedby="cancel-dialog-description"
        fullWidth={true}
        maxWidth={'sm'}

      >
        <DialogTitle id="cancel-dialog">
          Cancelar venta
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="cancel-dialog-description">
            ¿Deseas cancelar la venta?
          </DialogContentText>
          <TextField
            id="cancelReason"
            label="Razón de la cancelación"
            multiline
            rows={4}
            placeholder="Escribe una breve descripción por la cuál se cancela la venta"
            variant="outlined"
            onChange={(event) => setCancelReason(event.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Cerrar
          </Button>
          <Button
            onClick={() => cancelSale(selectedSale.id, selectedSale)}
            color="secondary"
            autoFocus
            disabled={!cancelReason}
          >
            Cancelar venta
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={view}
        onClose={handleViewClose}
        aria-labelledby="view-dialog"
        aria-describedby="view-dialog-description"
        fullWidth={true}
        maxWidth={'sm'}

      >
        <DialogTitle id="view-dialog">
          Detalles de venta
        </DialogTitle>
        <DialogContent>
          <List>
            <ListItem>
              <ListItemIcon>
                <CalendarTodayIcon />
              </ListItemIcon>
              <ListItemText primary={selectedSale?.date} />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <MonetizationOnIcon />
              </ListItemIcon>
              <ListItemText
                primary={`$${selectedSale?.total + (selectedSale?.extra || 0)}`}
                secondary={selectedSale?.extra ? `Con monto extra de $${selectedSale?.extra}` : ''}
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <AccountBalanceWalletIcon />
              </ListItemIcon>
              <ListItemText primary={paymentMethods[selectedSale?.paymentMethod]} />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <InfoIcon />
              </ListItemIcon>
              <ListItemText primary={salesStatus[selectedSale?.status]} />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <HelpOutlineIcon />
              </ListItemIcon>
              <ListItemText primary={selectedSale?.delivery ? 'Envío a domicilio' : 'Venta en local'} />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <NoteIcon />
              </ListItemIcon>
              <ListItemText primary={selectedSale?.notes || 'No hay notas'} />
            </ListItem>
          </List>
          <Grid container justifyContent="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<ReceiptIcon />}
                onClick={() => window.open(`/ticket/${selectedSale.id}`, '_blank')}
                style={{ marginBottom: '10px' }}
                disabled={selectedSale?.status !== 'completed'}
              >
                Ticket
              </Button>
            </Grid>
          </Grid>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Productos vendidos</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer>
                <Table aria-label="orders">
                  <TableHead>
                    <TableRow>
                      <TableCell>Producto</TableCell>
                      <TableCell align="right">Cantidad</TableCell>
                      <TableCell align="right">Precio</TableCell>
                      <TableCell align="right">Importe</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedSale && selectedSale.items.map(item => ({
                      quantity: item.quantity,
                      product: getProduct(item.product)
                    })).map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {row.product.name}
                        </TableCell>
                        <TableCell align="right">{row.quantity}</TableCell>
                        <TableCell align="right">${row.product.price}</TableCell>
                        <TableCell align="right">${row.product.price * row.quantity}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewClose}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}